import { motion, AnimatePresence } from 'framer-motion';
import { Z_RECONNECT } from '../../../features/quickstart/config/zIndexLayers';

interface ReconnectingOverlayProps {
  visible: boolean;
  attempt?: number;
}

export const ReconnectingOverlay = ({ visible, attempt }: ReconnectingOverlayProps) => (
  <AnimatePresence>
    {visible && (
      <motion.div
        className='pointer-events-none fixed inset-0 flex items-center justify-center'
        style={{ zIndex: Z_RECONNECT }}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.3 }}
      >
        <div className='flex flex-col items-center gap-3 rounded-2xl bg-black/70 px-8 py-6 backdrop-blur-sm'>
          <div className='h-6 w-6 animate-spin rounded-full border-2 border-white/30 border-t-white' />
          <span className='text-sm font-medium text-white'>
            Reconnecting{attempt && attempt > 1 ? ` (${attempt})` : ''}...
          </span>
        </div>
      </motion.div>
    )}
  </AnimatePresence>
);
